import { render, staticRenderFns } from "./ChooseSession.vue?vue&type=template&id=26edc6a1&scoped=true"
import script from "./ChooseSession.vue?vue&type=script&lang=js"
export * from "./ChooseSession.vue?vue&type=script&lang=js"
import style0 from "./ChooseSession.vue?vue&type=style&index=0&id=26edc6a1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26edc6a1",
  null
  
)

export default component.exports